import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetListOfValidDnpLinkOutput } from './GetListOfValidDnpLinkOutput';

export class GetListOfValidDnpLinkService extends HttpServiceBase {

    handle = (): Promise<Result<GetListOfValidDnpLinkOutput>|null> => {
        const promise = this.http.get<Result<GetListOfValidDnpLinkOutput>>(`${this.baseUrlZerezesApi}/dnp-link/list`);
        return promise;
    }
}